module.exports = __webpack_public_path__ + "media/luxury-2026/kingdom-living-eff2078d.jpg";